export function getContextualMenuStyles(props) {
    var theme = props.theme;
    var effects = theme.effects;
    var styles = {
        root: {
            borderRadius: effects.roundedCorner4,
            boxShadow: effects.elevation8,
        },
        container: {
            borderRadius: effects.roundedCorner4,
        },
        list: {
            padding: '4px',
        },
        subComponentStyles: {
            callout: {},
            menuItem: {
                root: {
                    borderRadius: effects.roundedCorner2,
                    '&:after': {
                        borderRadius: effects.roundedCorner2,
                    },
                },
                divider: {
                    margin: '4px',
                },
                icon: {
                    color: 'inherit',
                },
            },
        },
    };
    return styles;
}
//# sourceMappingURL=ContextualMenu.styles.js.map